if(!global._babelPolyfill){
    require("babel-polyfill");
}
import "../../commons/element-ui-css/element-ui.css";
import Vue from "vue";
import lang from "element-ui/lib/locale/lang/it.js";
import locale from "element-ui/lib/locale";

locale.use(lang);
import NotiziaView from "./notizia.vue";

import { dataApi, install } from "./data-api.js";
Vue.use(install);

import URI from "urijs";
const uri = new URI(location.href);
const not = uri.search(true).not;
if(not === null || not === undefined){
    location.href = window.NEWS_URLS.parent;
}

import Vuex from "vuex";
Vue.use(Vuex);
/* global process */
const store = new Vuex.Store({
    strict: process.env.NODE_ENV === "development",
    state: {
        user: null,
        not: not
    },
    mutations: {
        "setUser"(state, user){
            state.user = user;
        }
    }
});
let listener;
if(window.addEventListener){
    listener = window.addEventListener;
} else if(window.attachEvent){
    listener = window.attachEvent;
}

listener("load", function(){
    dataApi.getUserRoles()
    .then(resp => {
        store.commit("setUser", JSON.parse(resp.data));
        new Vue({
            store,
            render: (h) => {
                return h(NotiziaView);
            }
        }).$mount("#dettaglio-notizia");
    }).catch(() => {

    });
});
